import React, { useMemo } from 'react';
import { useI18n } from '@locales/client';
import { Link } from '@/shared/ui/link';
import {
  Section,
  SectionBlocks,
  SectionTitle,
  SectionViewAll,
} from './styles';
import { ConditionalWrapperGame } from '@/entities/game/ui/conditional-wrapper-game';
import { brandIsPw } from '@/shared/config/brand-by-target.mjs';

export type GameType = {
  imageUrl?: string;
  mobileLandscape?: boolean;
  title: string;
  providerName: string;
  wishlistToggleSlot: React.ReactNode;
  status?: string;
  id: string;
  // openNotAllowedModal: () => void;
  hasScroll?: boolean;
  denyBonus?: boolean;
  providerId: string;
};

type GameSectionProps = {
  games: GameType[];
  title: string;
  // openNotAllowedModal: () => void;
  rows: number;
  hasScroll: boolean;
  isGames: boolean;
  onGameClick: (game: GameType) => void;
  viewCount?: boolean;
  totalGamesCount?: number;
  activeBonusId?: number | null;
};

export const GameSection = ({
  games,
  title,
  // openNotAllowedModal,
  rows,
  hasScroll,
  isGames,
  onGameClick,
  viewCount,
  totalGamesCount,
  activeBonusId,
}: GameSectionProps) => {
  const t = useI18n();

  const viewAllUrl = useMemo(() => {
    return `/games${isGames ? `?filter=${title}` : ''}`;
  }, [isGames, title]);

  const count = useMemo(() => {
    if (isGames) {
      return games?.length;
    }
    return totalGamesCount;
  }, [isGames, games, totalGamesCount]);


  const displayedTitle = useMemo(() => {
    if (title === 'exclusive' && brandIsPw) {
      return t(`minibanners.pingWin_originals`);
    }
    
    const translated = t(`common.filter.category.${title}`);
    return translated.includes('common.filter.category.') ? title : translated;
  }, [t, title]);

  const renderGame = (game: GameType) => {
    return (
      <ConditionalWrapperGame
        key={game.id}
        game={game}
        handleClickGame={onGameClick}
        hasScroll={hasScroll}
        activeBonusId={activeBonusId}
      />
    );
  };

  return (
    !!games?.length && (
      <>
        <SectionBlocks>
          <SectionTitle>{displayedTitle}</SectionTitle>

          {viewCount && (
            <Link href={viewAllUrl} legacyBehavior>
              <SectionViewAll $count={count}>
                {t('common.filter.view_all')}
              </SectionViewAll>
            </Link>
          )}
        </SectionBlocks>

        <Section $hasScroll={hasScroll} $rows={rows}>
          {games.slice(0, rows * 20).map(renderGame)}
        </Section>
      </>
    )
  );
};
